import React from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {useIntl} from "react-intl";
import {FlagName, ProductEditValues} from "@/data/entities/menuEditor";
import {label} from "@/utils/LabelUtils";
import BooleanSelect from "@widgets/menuEditor/menu/product/fields/BooleanSelect";

const ALCOHOLIC: FlagName = "alcoholic";

type Props = {
    disabled: boolean,
};

/**
 * Whether the product contains alcohol (age check), stored as the `alcoholic`
 * flag.
 */
const AlcoholicField = ({disabled}: Props) => {
    const intl = useIntl();
    const {control, setValue} = useFormContext<ProductEditValues>();
    const value: FlagName[] = useWatch({control, name: "flags"});

    return (
        <BooleanSelect
            label={label("flag.alcoholic", true)}
            trueLabel={intl.formatMessage({id: "yes"})}
            falseLabel={intl.formatMessage({id: "no"})}
            value={value.includes(ALCOHOLIC)}
            onChange={(alcoholic: boolean) => setValue(
                "flags",
                alcoholic
                    ? [...value.filter(flag => flag !== ALCOHOLIC), ALCOHOLIC]
                    : value.filter(flag => flag !== ALCOHOLIC),
                {shouldDirty: true},
            )}
            disabled={disabled}
        />
    );
};

export default AlcoholicField;